import React from 'react';
import createCategoryRoute from '../utils/category-page';

import CategoryPage from '../components/common/CategoryPage';

import { selectInstrument } from '../selectors/instrument';
import { loadInstrument } from '../actions/instrument';

const route = createCategoryRoute({
  categorySelector: selectInstrument,
  categoryLoader: loadInstrument,
  facetType: 'instruments',
  contextFacet: 'Instrument',
  baseRoute: '/instruments',
});

const Instrument = ({ ...props }) => {
  return <CategoryPage {...props} />;
};

export default route(Instrument);
